export const GRID_LIST_REQUEST = 'GRID_LIST_REQUEST';
export const GRID_LIST_SUCCESS = 'GRID_LIST_SUCCESS';
export const REQUEST_FAILURE = 'REQUEST_FAILURE';
export const GRID_LIST_REQUEST_SELF_INSTALLER = 'GRID_LIST_REQUEST_SELF_INSTALLER';